import { createFileRoute } from "@tanstack/react-router";
import AdminPartEdit from "@/pages/admin/AdminPartEdit";

export const Route = createFileRoute("/_adminLayout/admin/parts/$productId")({
  component: AdminPartEdit,
});
